import { useLabReportFilterListAPI } from "@/app/hooks/api_hooks/LabReport/useLabReportFilterListAPI";
import { useLabReportStatsListAPI } from "@/app/hooks/api_hooks/LabReport/useLabReportStatsListAPI";
import useRouteInfo from "@/app/hooks/useRouteInfo";
import { ILabReportListState } from "@/app_redux/reducers/slices/auth/lab_report_slice";
import { useLocation, useNavigate } from "react-router";
interface Props {
  resetSelectedStatus: () => void;
}

const LabReportHeader = ({ resetSelectedStatus }: Props) => {
  // const LabReportHeader = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const fetchStatsList = useLabReportStatsListAPI();
  const { execute: fetchLabReports } = useLabReportFilterListAPI();
  const { labReportListFilter } = useRouteInfo("LAB_REPORT")?.routeState?.state as ILabReportListState;

  const callLabReportAPI = (tab: number) => {
    const constructedBody: any = {
      start_date: labReportListFilter?.start_date,
      end_date: labReportListFilter?.end_date,
      status_ids: labReportListFilter?.status_ids,
      clinic_ids: labReportListFilter?.clinic_ids,
      type: tab,
    };
    fetchStatsList(constructedBody);
    fetchLabReports(constructedBody);
  };

  const handleTabChange = (tab) => {
    resetSelectedStatus();
    if (tab === "internal") {
      callLabReportAPI(3);
      navigate("/app/lab-report/internal");
    } else if (tab === "external") {
      callLabReportAPI(1);
      navigate("/app/lab-report/external");
    } else if (tab === "incoming") {
      callLabReportAPI(2);
      navigate("/app/lab-report/incoming");
    }

  };

  return (
    <div className="bg-white px-1 mb-2">
      <div className="flex border-b border-gray-100 gap-4 sm:gap-10 overflow-x-auto scrollbar-hide">
        <div
          className={`pb-2 pt-1 cursor-pointer transition-all duration-200 relative shrink-0 ${location.pathname === "/app/lab-report/internal"
            ? "text-[#0467ff]"
            : "text-gray-500 hover:text-gray-700"
            }`}
          onClick={() => handleTabChange("internal")}
        >
          <p className="text-sm font-semibold whitespace-nowrap">Internal Requests</p>
          {location.pathname === "/app/lab-report/internal" && (
            <div className="absolute bottom-0 left-0 right-0 h-0.5 bg-[#0467ff] rounded-t-full" />
          )}
        </div>

        <div
          className={`pb-2 pt-1 cursor-pointer transition-all duration-200 relative shrink-0 ${location.pathname === "/app/lab-report/external"
            ? "text-[#0467ff]"
            : "text-gray-500 hover:text-gray-700"
            }`}
          onClick={() => handleTabChange("external")}
        >
          <p className="text-sm font-semibold whitespace-nowrap">External Requests</p>
          {location.pathname === "/app/lab-report/external" && (
            <div className="absolute bottom-0 left-0 right-0 h-0.5 bg-[#0467ff] rounded-t-full" />
          )}
        </div>

        <div
          className={`pb-2 pt-1 cursor-pointer transition-all duration-200 relative shrink-0 ${location.pathname === "/app/lab-report/incoming"
            ? "text-[#0467ff]"
            : "text-gray-500 hover:text-gray-700"
            }`}
          onClick={() => handleTabChange("incoming")}
        >
          <p className="text-sm font-semibold whitespace-nowrap">Incoming Requests</p>
          {location.pathname === "/app/lab-report/incoming" && (
            <div className="absolute bottom-0 left-0 right-0 h-0.5 bg-[#0467ff] rounded-t-full" />
          )}
        </div>
      </div>
    </div>
  );
};

export default LabReportHeader;
